import request from 'helpers/request';
import { PUSH_URL } from '../../constants/api';
import { Push } from './types';

export const postPush = (params: Push): Promise<string> =>
    request.post(PUSH_URL, params);
